import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const MyAcconutSetting = () => {
  const navigate = useNavigate();
  // loading
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://sakhisshop.com";

  const customerId = localStorage.getItem("customerId");

  // account details
  const [profile, setProfile] = useState({
    customerName: "",
    email: "",
    contactNumber: "",
  });
  const [isSavingProfile, setIsSavingProfile] = useState(false);
  const [profileMessage, setProfileMessage] = useState("");

  // password
  const [passwordForm, setPasswordForm] = useState({
    newPassword: "",
    currentPassword: "",
  });
  const [isSavingPassword, setIsSavingPassword] = useState(false);
  const [passwordMessage, setPasswordMessage] = useState("");

  const fetchProfile = async () => {
    if (!customerId) return;
    try {
      const res = await axios.get(
        `${API_BASE_URL}/api/customers/${customerId}`,
      );
      setProfile({
        customerName: res.data.customerName || "",
        email: res.data.email || "",
        contactNumber: res.data.contactNumber || "",
      });
    } catch (error) {
      console.error("Failed to fetch profile:", error);
    }
  };

  const handleProfileChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  const handleSaveProfile = async (e) => {
    e.preventDefault();
    if (!customerId) {
      setProfileMessage("❌ Unable to find account id. Please login again.");
      return;
    }

    try {
      setIsSavingProfile(true);
      setProfileMessage("");
      const res = await axios.put(
        `${API_BASE_URL}/api/customers/${customerId}`,
        profile,
      );

      const updated = res.data || profile;
      setProfile({
        customerName: updated.customerName || profile.customerName,
        email: updated.email || profile.email,
        contactNumber: updated.contactNumber || profile.contactNumber,
      });

      // keep cached user info in sync with the latest saved details
      const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
      localStorage.setItem(
        "user",
        JSON.stringify({ ...storedUser, ...updated }),
      );
      if (updated.customerName) {
        localStorage.setItem("customerName", updated.customerName);
      }

      setProfileMessage("✅ Details updated successfully!");
    } catch (error) {
      console.error("Failed to update profile:", error);
      setProfileMessage("❌ Failed to update details. Please try again.");
    } finally {
      setIsSavingProfile(false);
    }
  };

  const handlePasswordChange = (e) => {
    setPasswordForm({ ...passwordForm, [e.target.name]: e.target.value });
  };

  const handleSavePassword = async (e) => {
    e.preventDefault();
    if (!customerId) {
      setPasswordMessage("❌ Unable to find account id. Please login again.");
      return;
    }
    if (!passwordForm.currentPassword || !passwordForm.newPassword) {
      setPasswordMessage("❌ Please fill in both password fields.");
      return;
    }

    try {
      setIsSavingPassword(true);
      setPasswordMessage("");
      await axios.put(`${API_BASE_URL}/api/customers/${customerId}`, {
        password: passwordForm.newPassword,
        currentPassword: passwordForm.currentPassword,
      });
      setPasswordForm({ newPassword: "", currentPassword: "" });
      setPasswordMessage("✅ Password updated successfully!");
    } catch (error) {
      console.error("Failed to update password:", error);
      setPasswordMessage(
        error.response?.data?.error ||
          "❌ Failed to update password. Please try again.",
      );
    } finally {
      setIsSavingPassword(false);
    }
  };

  const handleDeleteAccount = async () => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const role = (localStorage.getItem("role") || "").toUpperCase();

    const userId =
      storedUser?.id ||
      storedUser?.userId ||
      (localStorage.getItem("userId")
        ? Number(localStorage.getItem("userId"))
        : null);

    const customerId = localStorage.getItem("customerId");

    let deleteUrl = "";
    if (userId) {
      deleteUrl = `${API_BASE_URL}/api/users/delete-account/${userId}`;
    } else if (role === "CUSTOMER" && customerId) {
      deleteUrl = `${API_BASE_URL}/api/customers/${customerId}`;
    }

    if (!deleteUrl) {
      alert("Unable to find account id. Please login again and retry.");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete your account? This action cannot be undone.",
    );
    if (!confirmed) return;

    try {
      setIsDeleting(true);

      const token = localStorage.getItem("token");
      await axios.delete(deleteUrl, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });

      localStorage.clear();
      alert("Your account has been deleted successfully.");
      navigate("/MyAccountsSignIn");
    } catch (error) {
      console.error("Delete account failed:", error);
      alert("Failed to delete account. Please try again.");
    } finally {
      setIsDeleting(false);
    }
  };

  useEffect(() => {
    fetchProfile();
    setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <>
        <ScrollToTop />
      </>
      <>
        <div>
          {/* section */}
          <section>
            {/* container */}
            <div className="container">
              {/* row */}
              <div className="row">
                {/* col */}
                <div className="col-12">
                  <div className="p-6 d-flex justify-content-between align-items-center d-md-none">
                    {/* heading */}
                    <h3 className="fs-5 mb-0">Account Setting</h3>
                    {/* btn */}
                    <button
                      className="btn btn-outline-gray-400 text-muted d-md-none"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasAccount"
                      aria-controls="offcanvasAccount"
                    >
                      <i className="fas fa-bars"></i>
                    </button>
                  </div>
                </div>
                {/* col */}
                <div className="col-lg-3 col-md-4 col-12 border-end  d-none d-md-block">
                  <div className="pt-10 pe-lg-10">
                    {/* nav item */}
                    <ul className="nav flex-column nav-pills nav-pills-dark">
                      <li className="nav-item">
                        <Link
                          className="nav-link "
                          aria-current="page"
                          to="/MyAccountOrder"
                        >
                          <i className="fas fa-shopping-bag me-2" />
                          Your Orders
                        </Link>
                      </li>
                      {/* nav item */}
                      <li className="nav-item">
                        <Link
                          className="nav-link active"
                          to="/MyAccountSetting"
                        >
                          <i className="fas fa-cog me-2" />
                          Settings
                        </Link>
                      </li>
                      {/* nav item */}
                      <li className="nav-item">
                        <Link className="nav-link" to="/MyAccountAddress">
                          <i className="fas fa-map-marker-alt me-2" />
                          Address
                        </Link>
                      </li>
                      {/* nav item */}
                      {/* <li className="nav-item">
                        <Link className="nav-link" to="/MyAcconutPaymentMethod">
                          <i className="fas fa-credit-card me-2" />
                          Payment Method
                        </Link>
                      </li> */}
                      {/* nav item */}
                      <li className="nav-item">
                        <Link className="nav-link" to="/MyAcconutNotification">
                          <i className="fas fa-bell me-2" />
                          Notification
                        </Link>
                      </li>
                      {/* nav item */}
                      <li className="nav-item">
                        <hr />
                      </li>
                      {/* nav item */}
                      <li className="nav-item">
                        <Link className="nav-link " to="/Grocery-react/">
                          <i className="fas fa-sign-out-alt me-2" />
                          Log out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-9 col-md-8 col-12">
                  <div>
                    {loaderStatus ? (
                      <div className="loader-container">
                        {/* <PulseLoader loading={loaderStatus} size={50} color="#0aad0a" /> */}
                        <MagnifyingGlass
                          visible={true}
                          height="100"
                          width="100"
                          ariaLabel="magnifying-glass-loading"
                          wrapperStyle={{}}
                          wrapperclassName="magnifying-glass-wrapper"
                          glassColor="#c0efff"
                          color="#0aad0a"
                        />
                      </div>
                    ) : (
                      <>
                        <div className="p-6 p-lg-10">
                          <div className="mb-6">
                            {/* heading */}
                            <h2 className="mb-0">Account Setting</h2>
                          </div>
                          <div>
                            {/* heading */}
                            <h5 className="mb-4">Account details</h5>
                            <div className="row">
                              <div className="col-lg-5">
                                {/* form */}
                                <form onSubmit={handleSaveProfile}>
                                  {/* input */}
                                  <div className="mb-3">
                                    <label className="form-label">Name</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="customerName"
                                      placeholder="Your name"
                                      value={profile.customerName}
                                      onChange={handleProfileChange}
                                    />
                                  </div>
                                  {/* input */}
                                  <div className="mb-3">
                                    <label className="form-label">Email</label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      name="email"
                                      placeholder="example@gmail.com"
                                      value={profile.email}
                                      onChange={handleProfileChange}
                                    />
                                  </div>
                                  {/* input */}
                                  <div className="mb-5">
                                    <label className="form-label">Phone</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="contactNumber"
                                      placeholder="Phone number"
                                      value={profile.contactNumber}
                                      onChange={handleProfileChange}
                                    />
                                  </div>
                                  {/* message */}
                                  {profileMessage && (
                                    <p
                                      className={
                                        profileMessage.startsWith("✅")
                                          ? "text-success"
                                          : "text-danger"
                                      }
                                    >
                                      {profileMessage}
                                    </p>
                                  )}
                                  {/* button */}
                                  <div className="mb-3">
                                    <button
                                      type="submit"
                                      className="btn btn-primary"
                                      disabled={isSavingProfile}
                                    >
                                      {isSavingProfile
                                        ? "Saving..."
                                        : "Save Details"}
                                    </button>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                          <hr className="my-10" />
                          <div className="pe-lg-14">
                            {/* heading */}
                            <h5 className="mb-4">Password</h5>
                            <form
                              className=" row row-cols-1 row-cols-lg-2"
                              onSubmit={handleSavePassword}
                            >
                              {/* input */}
                              <div className="mb-3 col">
                                <label className="form-label">
                                  New Password
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="newPassword"
                                  placeholder="**********"
                                  value={passwordForm.newPassword}
                                  onChange={handlePasswordChange}
                                />
                              </div>
                              {/* input */}
                              <div className="mb-3 col">
                                <label className="form-label">
                                  Current Password
                                </label>
                                <input
                                  type="password"
                                  className="form-control"
                                  name="currentPassword"
                                  placeholder="**********"
                                  value={passwordForm.currentPassword}
                                  onChange={handlePasswordChange}
                                />
                              </div>
                              {/* message */}
                              {passwordMessage && (
                                <div className="col-12">
                                  <p
                                    className={
                                      passwordMessage.startsWith("✅")
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {passwordMessage}
                                  </p>
                                </div>
                              )}
                              {/* input */}
                              <div className="col-12">
                                <p className="mb-4">
                                  Can’t remember your current password?
                                  <Link to="/MyAccountForgetPassword">
                                    {" "}
                                    Reset your password.
                                  </Link>
                                </p>
                                <button
                                  type="submit"
                                  className="btn btn-primary"
                                  disabled={isSavingPassword}
                                >
                                  {isSavingPassword
                                    ? "Saving..."
                                    : "Save Password"}
                                </button>
                              </div>
                            </form>
                          </div>
                          <hr className="my-10" />
                          <div>
                            {/* heading */}
                            <h5 className="mb-4">Delete Account</h5>
                            <p className="mb-2">
                              Would you like to delete your account?
                            </p>
                            <p className="mb-5">
                              This account contain 12 orders, Deleting your
                              account will remove all the order details
                              associated with it.
                            </p>
                            {/* btn */}
                            <button
                              type="button"
                              className="btn btn-outline-danger"
                              onClick={handleDeleteAccount}
                              disabled={isDeleting}
                            >
                              {isDeleting
                                ? "Deleting..."
                                : "I want to delete my account"}
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* modal */}
          <div
            className="offcanvas offcanvas-start"
            tabIndex={-1}
            id="offcanvasAccount"
            aria-labelledby="offcanvasAccountLabel"
          >
            {/* offcanvas header */}
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasAccountLabel">
                My Account
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              />
            </div>
            {/* offcanvas body */}
            <div className="offcanvas-body">
              <ul className="nav flex-column nav-pills nav-pills-dark">
                {/* nav item */}
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    aria-current="page"
                    href="/MyAccountOrder"
                  >
                    <i className="fas fa-shopping-bag me-2" />
                    Your Orders
                  </a>
                </li>
                {/* nav item */}
                <li className="nav-item">
                  <a className="nav-link " href="/MyAccountSetting">
                    <i className="fas fa-cog me-2" />
                    Settings
                  </a>
                </li>
                {/* nav item */}
                <li className="nav-item">
                  <a className="nav-link" href="/MyAccountAddress">
                    <i className="fas fa-map-marker-alt me-2" />
                    Address
                  </a>
                </li>
                {/* nav item */}
                <li className="nav-item">
                  <a className="nav-link" href="/MyAcconutPaymentMethod">
                    <i className="fas fa-credit-card me-2" />
                    Payment Method
                  </a>
                </li>
                {/* nav item */}
                <li className="nav-item">
                  <a className="nav-link" href="/MyAcconutNotification">
                    <i className="fas fa-bell me-2" />
                    Notification
                  </a>
                </li>
              </ul>
              <hr className="my-6" />
              <div>
                {/* nav  */}
                <ul className="nav flex-column nav-pills nav-pills-dark">
                  {/* nav item */}
                  <li className="nav-item">
                    <a className="nav-link " href="/Grocery-react/">
                      <i className="fas fa-sign-out-alt me-2" />
                      Log out
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default MyAcconutSetting;
